<template>
    <div class="bg-white">
        <div class="d-sm-down-none">
            <Mainlayout></Mainlayout>
            <CCol sm="12" class="bg-white">
                <CContainer>
                    <CRow>
                        <CCol sm="8" style="margin-top: 10%;">
                            <h3 class="custom-36px-600 font-color-171717">Notification</h3>
                        </CCol>
                        <CCol sm="4" style="margin-top: 10%;">
                            <CButton class="badge-purple bg-928AFD text-white p-2">
                                All Notification
                            </CButton>
                            <CButton class="badge-purple p-2 font-color-928AFD ml-2">
                                Unread
                            </CButton>
                            <CButton class="badge-purple font-color-928AFD p-2 ml-2">
                                Feedback
                            </CButton>
                        </CCol>
                    </CRow>
                </CContainer>
            </CCol>
            <CCol sm="12" class="bg-white">
                <CContainer>
                <CCard class="border-EAECF0 p-4">
                    <h3 class="custom-16px-600 text-left">Today</h3>
                    <CRow>
                        <CCol sm="1">
                            <img src="../assets/img/iconstarnoti.png" style="max-width:50px"/>
                        </CCol>
                        <CCol sm="10">
                            <h3 class="custom-18px-500 text-left mt-1">New Car Review Available</h3>
                            <h4 class="custom-16px-400 text-left font-color-696969">A new review for the BMW123 is now available—check out the latest insights and ratings!</h4>
                        </CCol>
                        <CCol sm="1">
                            <h3 class="custom-14px-400 text-right mt-1 font-color-696969">8h</h3>
                        </CCol>

                        <CCol sm="1">
                            <img src="../assets/img/iconstarnoti.png" style="max-width:50px"/>
                        </CCol>
                        <CCol sm="10">
                            <h3 class="custom-18px-500 text-left mt-1">Car Recommendation</h3>
                            <h4 class="custom-16px-400 text-left font-color-696969">We have a new car recommendation based on your preferences—check out the BMW123 that suits you best!</h4>
                        </CCol>
                        <CCol sm="1">
                            <h3 class="custom-14px-400 text-right mt-1 font-color-696969">8h</h3>
                        </CCol>

                        <CCol sm="1">
                            <img src="../assets/img/iconstarnoti.png" style="max-width:50px"/>
                        </CCol>
                        <CCol sm="10">
                            <h3 class="custom-18px-500 text-left mt-1">Test Drive Invitation</h3>
                            <h4 class="custom-16px-400 text-left font-color-696969">You're invited to test drive the BMW123 at a dealership near you—schedule your drive today!</h4>
                        </CCol>
                        <CCol sm="1">
                            <h3 class="custom-14px-400 text-right mt-1 font-color-696969">8h</h3>
                        </CCol>

                        
                    </CRow>
                </CCard>

                <CCard class="border-EAECF0 p-4">
                    <h3 class="custom-16px-600 text-left">Yesterday</h3>
                    <CRow>
                        <CCol sm="1">
                            <img src="../assets/img/iconstarnoti.png" style="max-width:50px"/>
                        </CCol>
                        <CCol sm="10">
                            <h3 class="custom-18px-500 text-left mt-1">New Car Review Available</h3>
                            <h4 class="custom-16px-400 text-left font-color-696969">A new review for the BMW123 is now available—check out the latest insights and ratings!</h4>
                        </CCol>
                        <CCol sm="1">
                            <h3 class="custom-14px-400 text-right mt-1 font-color-696969">8h</h3>
                        </CCol>

                        <CCol sm="1">
                            <img src="../assets/img/iconstarnoti.png" style="max-width:50px"/>
                        </CCol>
                        <CCol sm="10">
                            <h3 class="custom-18px-500 text-left mt-1">Car Recommendation</h3>
                            <h4 class="custom-16px-400 text-left font-color-696969">We have a new car recommendation based on your preferences—check out the BMW123 that suits you best!</h4>
                        </CCol>
                        <CCol sm="1">
                            <h3 class="custom-14px-400 text-right mt-1 font-color-696969">8h</h3>
                        </CCol>

                        <CCol sm="1">
                            <img src="../assets/img/iconstarnoti.png" style="max-width:50px"/>
                        </CCol>
                        <CCol sm="10">
                            <h3 class="custom-18px-500 text-left mt-1">Test Drive Invitation</h3>
                            <h4 class="custom-16px-400 text-left font-color-696969">You're invited to test drive the BMW123 at a dealership near you—schedule your drive today!</h4>
                        </CCol>
                        <CCol sm="1">
                            <h3 class="custom-14px-400 text-right mt-1 font-color-696969">8h</h3>
                        </CCol>

                        
                    </CRow>
                </CCard>
                </CContainer>
                <br /> <br /> <br />
            </CCol>
        </div>
    
    
    
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

import _ from "lodash";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurplerectangle.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheBottomCustom.vue";
import Footerweb from "../containers/FooterWeb.vue";
import ToggleCard from '../components/Toggle.vue';
import backgroundUrNoArrow from "../assets/img/bgline.png";

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
        Footerweb
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrNoArrow

        };
    },
    created() {
        AOS.init();

    },
    methods: {
        GoToEvoucher() {
            this.$router.push("SelectionEvoucher");
        }
    }


};
</script>


<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
</style>
